import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {persistReducer} from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
 
import mainSlice from "./../features/MainSlice";
import userDataSlice from "../permissions/UserDataSlice";
import permissionsSlice from "../permissions/permissionDataSlice";
import statusPageSlices from "../statusPageSlice";
import scorecardDataSlice from "../scorecard/scorecardDataSlice";

import { persistStore } from 'redux-persist';

const persistConfig = {
  key: "root",
  storage,
  whitelist:["userDataSlice"]
}; 

const rootReducer = combineReducers({
  mainSlice,
  permissionsSlice,
  userDataSlice,
  statusPageSlices,
  scorecardDataSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer:persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
 
export const persistor = persistStore(store);

export const clearPersistedState = () => {
  persistor.purge();
};